<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row margin-bottom-x2">
    <mat-button-toggle-group formControlName="produktId" aria-label="Produkt" (change)="onProductChange($event)">
      @for (product of products; track product) {
        <mat-button-toggle [value]="product.id">
          <mat-icon [svgIcon]="product.text.toLowerCase()"></mat-icon>
          {{ product.text }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>

  @if (form.value.produktId) {
    @if (fabrikater) {
      <app-fabrikat-input
        [form]="form"
        [fabrikater]="fabrikater"
        [selectFabrikat$]="selectFabrikat$"
        (fabrikatChange)="onFabrikatChange($event)"
      ></app-fabrikat-input>
    }
    <div></div>
    @if (fabrikatWarning) {
      <div>
        <em>Du skal sikre dig OK fra relevant servicechef og s-partner, før du opretter serviceaftale på dette fabrikat.</em>
      </div>
    }
    @if (modeller && fabrikatId.value) {
      <app-model-input
        appearance="outline"
        showLabel="false"
        [form]="form"
        [modeller]="modeller"
        [selectModel$]="selectModel$"
        (modelChange)="onModelChange($event)"
      ></app-model-input>
    }
    <div></div>
    @if (modelWarning) {
      <div>
        <em>Du skal sikre dig OK fra relevant servicechef og s-partner, før du opretter serviceaftale på denne model.</em>
      </div>
    }
    <div class="form-row flex">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Effekt</mat-label>
          <input formControlName="effekt" matInput />
          <span matSuffix>kW</span>
          @if (effekt.hasError('pattern')) {
            <mat-error>Min/Max værdier = x-y. F.eks. 100-200</mat-error>
          }
          @if (effekt.hasError('minmax')) {
            <mat-error>Maksimum effekt skal være større end minimum effekt.</mat-error>
          }
          @if (effekt.hasError('produkt')) {
            <mat-error>Minimum og maksimum effekt ikke tilladt for varmepumper.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Serienummer</mat-label>
        <input formControlName="serienummer" matInput />
      </mat-form-field>
    </div>
    @if (installatoerer && canWrite) {
      <app-installatoer-input
        appearance="outline"
        showLabel="false"
        [form]="form"
        [installatoerer]="installatoerer"
        (installatoerChange)="onInstallatoerChange($event)"
      ></app-installatoer-input>
    }
    <div class="form-row flex">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Installations dato</mat-label>
          <mat-datepicker-toggle matPrefix [for]="installationDatePicker"></mat-datepicker-toggle>
          <input #installationInput matInput [matDatepicker]="installationDatePicker" formControlName="installationDate" />
          <mat-datepicker #installationDatePicker></mat-datepicker>
          @if (installationDate.hasError('komponent')) {
            <mat-error>{{ installationDate.errors.komponent }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Garantiperiode</mat-label>
          <input type="number" formControlName="garantiPeriode" matInput />
          <span matSuffix>mdr.</span>
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">
      @if (erOlie) {
        <mat-slide-toggle color="primary" formControlName="kondenserende">Kondenserende</mat-slide-toggle>
      }
    </div>
    <div class="form-row margin-bottom-x2">
      @if (erGas || erOlie) {
        <mat-slide-toggle color="primary" formControlName="storbraender" (change)="onStorbraenderChange()">Storbrænder</mat-slide-toggle>
      }
    </div>
    <!--Only oil and gas-->
    @if (isStorBraender && (erGas || erOlie)) {
      <div class="form-row">
        <label class="form-headline">Driftform</label>
        <mat-radio-group formControlName="driftformId">
          @for (driftform of driftformer; track driftform) {
            <mat-radio-button [value]="driftform.id">{{ driftform.text | titlecase }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }
    <div class="form-row margin-bottom-x2">
      <h2 class="form-headline flex-wrap flex-wrap--flex-start">
        Komponenter
        <app-info tooltip="Komponenten er den specifikke bestanddel af et anlæg (eksempelvis en keddel)." inline="true"></app-info>
      </h2>
      @for (komponent of komponenterControls; track komponent) {
        <div class="prod-unit">
          <h3 class="detail-rows-header">
            {{ komponentTypeMap.get(komponent.controls.komponentTypeId.value) }}
            <span class="prod-unit__edit">
              <button (click)="editKomponent(komponent)" class="btn-icon" aria-label="Rediger komponent" title="Rediger komponent">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            </span>
          </h3>
          <div class="detail-rows">
            <div class="prod-unit__delete">
              <button (click)="deleteKomponent(komponent)" class="btn-icon" aria-label="Slet komponent" title="Slet komponent">
                <mat-icon class="normal-state" svgIcon="delete"></mat-icon>
                <mat-icon class="hover-state" svgIcon="delete-forever"></mat-icon>
              </button>
            </div>
            <div class="detail-row">
              <div class="detail-row__lbl">Model</div>
              <div class="detail-row__val">{{ komponent.controls.model.value }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-row__lbl">Installations dato</div>
              <div class="detail-row__val">{{ komponent.controls.installationDate.value | date: 'dd.MM.yyyy' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-row__lbl">Garantiperiode</div>
              @if (komponent.controls.garantiPeriode.value) {
                <div class="detail-row__val">
                  {{ komponent.controls.garantiPeriode.value }} måneder ({{
                    getGarantiEndDate(komponent.controls.installationDate.value, komponent.controls.garantiPeriode.value)
                      | date: 'dd.MM.yyyy'
                  }})
                </div>
              }
            </div>
            <div class="detail-row">
              <div class="detail-row__lbl">SE-nr.</div>
              <div class="detail-row__val">{{ komponent.controls.serienummer.value }}</div>
            </div>
          </div>
        </div>
      }
      <div>
        <button type="button" class="btn-icon blue btn-add-small" (click)="addKomponent()">
          <mat-icon svgIcon="add-small"></mat-icon>
          <span>Tilføj komponent</span>
        </button>
      </div>
    </div>
  }
</form>
